import { render, staticRenderFns } from "./BaseFiles.vue?vue&type=template&id=3e78e3d2"
import script from "./BaseFiles.vue?vue&type=script&lang=js"
export * from "./BaseFiles.vue?vue&type=script&lang=js"
import style0 from "./BaseFiles.vue?vue&type=style&index=0&id=3e78e3d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports